import type { InboxItem } from "./updates";
export type PresentedReview = {
  comments: { id: string; signature: string; occurrences?: string[] }[];
  actions: { id: string; updatedAt: number }[];
};
// A later reply must match its own displayed version. Legacy notifications can
// acknowledge an explicit open intent, never a blanket thread visit.
export function notificationWasPresented(
  item: InboxItem,
  shown: PresentedReview,
  intent?: { id: string; updated_at: number },
) {
  let occurrences:string[]=[];
  try { occurrences=JSON.parse(item.source_occurrences??"[]"); }catch{}
  const sourcePresented =
    !!(item.source_comment_id && item.source_signature) &&
    shown.comments.some(
      (c) =>
        c.id === item.source_comment_id &&
        (c.signature === item.source_signature || (c.occurrences??[]).some(id=>occurrences.includes(id))),
    );
  if (item.kind === "assignment" && item.action_id)
    return shown.actions.some(
      (a) =>
        a.id === item.action_id &&
        (a.updatedAt >= item.updated_at || sourcePresented),
    );
  if (item.source_comment_id && item.source_signature) return sourcePresented;
  return (
    !!intent &&
    intent.id === item.id &&
    intent.updated_at === item.updated_at &&
    shown.comments.length > 0
  );
}
